export default {
  getGeometrySelection: (state) =>
    Object.keys(state.geometrySelection).find(
      (k) => state.geometrySelection[k]
    ),
  getSelectionMode: (state) => state.selectionMode
};
